import React from 'react';
import Switch from 'react-switch';
import './Toggle.css';

const Toggle = ({ checked, onChange, label, disabled = false }) => {
  return (
    <div className="toggle-container">
      <label>{label}</label>
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        onColor="#0E5F79"
        offColor="#E5E5E5"
        checkedIcon={false}
        uncheckedIcon={false}
        height={25}
        width={50}
        handleDiameter={19}
        boxShadow="0 2px 4px rgba(0, 0, 0, 0.2)"
        activeBoxShadow="0 2px 4px rgba(0, 0, 0, 0.2)"
      />
    </div>
  );
};

export default Toggle;
